export default import.meta.ROLLDOWN_FILE_URL_nEZDY4AJiMya1ACAasgb4g